import { Button, Typography } from '@breetometer/components';
import { CancelIcon } from 'BreetAssets';

import type { IStickyNotification } from '../NotificationBanner.helpers';

export const StickyNotification = ({ message, buttonTitle, onButtonClick, onCancel, status }: IStickyNotification) => (
	<div
		className={`sticky ${status}`}
		data-testid='notification-banner'
	>
		<div className='sticky_container'>
			<Typography>{message}</Typography>
			<Button
				onClick={onButtonClick}
				label={buttonTitle}
			/>

			<CancelIcon
				onClick={onCancel}
				aria-label='Close notification'
				className='sticky_closebutton'
				variant='dropdown'
			/>
		</div>
	</div>
);
